import React, { useEffect, useState } from 'react';
import { Badge, Button, Modal } from 'react-bootstrap-5';

import { faFlask } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingBar from 'bundles/connect/components/call_lists/import/loading_bar';
import { getRethinkCallListSync } from 'bundles/connect/helpers/prospect_api';
import type { RethinkCallListSync } from 'bundles/connect/types';

type EnrichListModalLoadingProps = {
  setModalStage: (stage: number) => void;
  sendEmail: boolean;
  rethinkSync?: RethinkCallListSync;
}

export default function EnrichListModalLoading({
  setModalStage,
  sendEmail,
  rethinkSync
}: EnrichListModalLoadingProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!rethinkSync) return;

    const interval = setInterval(async () => {
      const data = await getRethinkCallListSync(rethinkSync.id);
      if (data.syncProgress === 100) {
        setModalStage(3);
      } else {
        setProgress(data.syncProgress);
      }
    }, 1500);
    return () => clearInterval(interval);
  }, [rethinkSync]);

  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <div className="d-flex flex-column w-100">
          <Badge bg="" className="text-body fw-normal rounded muted me-auto" style={{ fontSize: '0.875rem' }}>
            <FontAwesomeIcon className="me-1 text-secondary" icon={faFlask} />
            BETA
          </Badge>
          <Modal.Title as="h5">Enriching List</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>
          We're searching for contacts inside your list.
          Feel free to close this dialog.
          {sendEmail ? 'We will email you when the job is completed' : ''}
        </p>
        <LoadingBar progress={progress} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="text-primary" onClick={() => setModalStage(0)}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}
